import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { REGISTER_USER } from './actionTypes';
import { registerUserSuccessful, registerUserFailed } from './actions';

// Include call API
import { getUsersAPI } from "../../../api/users";

const usersAPI = getUsersAPI();

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user, history } }) {
    try {
        const response = yield call(usersAPI.registerUser, user.name, user.pass, user.role_id, user.token);
        yield put(registerUserSuccessful(response.message));
    } catch (error) {
        yield put(registerUserFailed(error));
    }
}

export function* watchUserRegister() {
    yield takeEvery(REGISTER_USER, registerUser);
}

function* accountSaga() {
    yield all([fork(watchUserRegister)]);
}

export default accountSaga;